exports.init = GetBasfNotConfiguredEntities;

function GetBasfNotConfiguredEntities() {
  const btnUsuarioNaoConfiguradosBasf = $('#btnUsuarioNaoConfiguradoBasf');
  btnUsuarioNaoConfiguradosBasf.on('click', GetUsuariosEntities);

  const btnDespesasTipoNaoConfiguradosBasf = $('#btnDespesasTipoNaoConfiguradoBasf');
  btnDespesasTipoNaoConfiguradosBasf.on('click', GetTiposDespesaEntities);

  const btnProjetosNaoConfiguradosBasf = $('#btnProjetosNaoConfiguradoBasf');
  btnProjetosNaoConfiguradosBasf.on('click', GetProjetosEntities);
}

function GetUsuariosEntities() {
  const modalUsuariosNaoConfiguradosBasf = $('#modalUsuariosNaoConfiguradosBasf')
  $.ajax({
    type: 'GET',
    url: route('app.admin.integracoes.basf.usuarios-nao-configurados')
  }).done(response => {
    modalUsuariosNaoConfiguradosBasf.html(response);
  });
}

function GetTiposDespesaEntities() {
  const modalTiposDespesaNaoConfiguradosBasf = $('#modalDespesasTipoNaoConfiguradosBasf')
  $.ajax({
    type: 'GET',
    url: route('app.admin.integracoes.basf.tipos-despesa-nao-configurados')
  }).done(response => {
    modalTiposDespesaNaoConfiguradosBasf.html(response);
  });
}

function GetProjetosEntities() {
  const modalProjetosNaoConfiguradosBasf = $('#modalProjetosNaoConfiguradosBasf')
  $.ajax({
    type: 'GET',
    url: route('app.admin.integracoes.basf.projetos-nao-configurados')
  }).done(response => {
    modalProjetosNaoConfiguradosBasf.html(response);
  });
}